import { Eye, EyeOff } from '@aktiia/design-system';
import cx from 'classnames';
import { useState } from 'react';

import { IPasswordInputProps } from './types';

export const PasswordInput = ({ value, onChange, placeholder, className, autoComplete }: IPasswordInputProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const toggleShowPassword = () => setShowPassword(!showPassword);

  return (
    <div className="flex flex-1 relative items-center">
      <input
        type={showPassword ? 'text' : 'password'}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder ?? undefined}
        autoComplete={autoComplete}
        className={cx(className, 'h-[48px] pr-12')}
      />

      <div className="absolute right-4">
        {showPassword ? (
          <EyeOff className="cursor-pointer" onClick={toggleShowPassword} />
        ) : (
          <Eye className="cursor-pointer" onClick={toggleShowPassword} />
        )}
      </div>
    </div>
  );
};
